import { GetterTree } from "vuex";
import { IReportTemplateState } from "@/store/modules/reportTemplate/state";
import { ReportTemplate } from "@/types/report/ReportTypes";
import { IDataProvider, IRootState } from "@/store";

export enum ReportTemplateGetters {
  GET_ALL = "GET_ALL_REPORT_TEMPLATE",
  GET_CURRENT = "GET_CURRENT_REPORT_TEMPLATE",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_REPORT_TEMPLATE",
}

export const getters: GetterTree<IReportTemplateState, IRootState> = {
  [ReportTemplateGetters.GET_ALL](state): ReportTemplate[] | null {
    return state.reportTemplates;
  },
  [ReportTemplateGetters.GET_CURRENT](state): ReportTemplate | null {
    return state.reportTemplate;
  },
  [ReportTemplateGetters.GET_DATA_PROVIDER](
    state
  ): IDataProvider<ReportTemplate> | null {
    return state.dataProvider;
  },
};
